export const getGimblettGravelsData = () => ({
  name: "Gimblett Gravels",
  region: "Hawke's Bay",
  country: "Nouvelle-Zélande",
  description: "Gimblett Gravels est un terroir unique dans Hawke's Bay, caractérisé par ses sols de graviers déposés par la rivière Ngaruroro. Ce terroir chaud et sec est spécialisé dans la production de vins rouges de qualité, notamment le Merlot et le Syrah.",
  type: "subregion",
  area: "800 ha",
  production: "0.06 million hectolitres",
  climate: "Climat chaud et sec avec influences maritimes, étés longs et hivers doux",
  soil: "Sols de graviers, excellente drainage, faible fertilité",
  characteristics: {
    climate: "Climat chaud et sec avec influences maritimes, étés longs et hivers doux",
    soil: "Sols de graviers, excellente drainage, faible fertilité",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Vins rouges structurés et fruités, avec des tanins mûrs et une excellente complexité",
    white: "Chardonnay sec et équilibré avec notes de fruits blancs",
    rosé: "Rosés élégants et fruités, parfaits pour l'apéritif"
  },
  history: "La viticulture à Gimblett Gravels a commencé dans les années 1980 avec la reconnaissance du potentiel unique de ce terroir. Les sols de graviers, combinés au climat chaud et sec, créent des conditions idéales pour la production de vins rouges de qualité. Aujourd'hui, Gimblett Gravels est reconnu comme l'un des meilleurs terroirs de Nouvelle-Zélande pour les vins rouges.",
  foodPairing: "Viandes rouges, fromages affinés, plats méditerranéens, cuisine locale",
  grapeVarieties: [
    {
      name: "Merlot",
      percentage: "45%",
      description: "Cépage rouge principal, produisant des vins structurés et fruités",
      characteristics: "Structuré, fruité, tanins mûrs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Syrah",
      percentage: "25%",
      description: "Cépage rouge produisant des vins élégants et épicés",
      characteristics: "Élégant, épicé, tanins fins",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Cabernet Sauvignon",
      percentage: "15%",
      description: "Cépage rouge produisant des vins puissants et tanniques",
      characteristics: "Puissant, tannique, notes de cassis",
      wineStyles: "Sec, plein-corps, complexe"
    },
    {
      name: "Chardonnay",
      percentage: "15%",
      description: "Cépage blanc principal, produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    }
  ],
  statistics: {
    totalArea: "800 ha",
    production: "0.06 million hectolitres",
    wineries: "25+ domaines",
    exportPercentage: "60%"
  },
  viticulture: "La viticulture à Gimblett Gravels se caractérise par l'attention aux détails et la recherche de la qualité. Les rendements sont limités pour préserver l'intensité aromatique et la concentration. L'irrigation est utilisée pour optimiser la croissance des vignes dans ce terroir sec.",
  winemaking: "La vinification se fait principalement en fûts de chêne pour ajouter de la complexité. La macération prolongée et l'élevage en barriques sont courants. La fermentation malolactique est souvent pratiquée pour adoucir l'acidité.",
  terroir: "Gimblett Gravels est caractérisé par ses sols de graviers déposés par la rivière Ngaruroro. Ces sols offrent un excellent drainage et une faible fertilité, forçant les vignes à développer des racines profondes. Le climat chaud et sec, combiné aux influences maritimes, crée des conditions idéales pour la maturation des raisins rouges.",
  mapAreas: [
    { region: "Gimblett Gravels", x: 176.8, y: -39.5, color: "#4B164C", size: 5 }
  ]
}); 